import APIRequest from './APIRequest';

export const GetRoles = () =>
  APIRequest({
    url: 'Role/GetRoles',
    method: 'get'
  })